import stringToDate from './stringToDate';

const ISO_DATE_FORMAT = /^\d{4}-\d{2}-\d{2}$/;

/**
 * Parses a `YYYY-MM-DD` string into a date, or null when the string is not a real calendar date.
 *
 * Matching the shape is not enough: Date rolls over out of range values silently, so "2026-02-30"
 * comes back as March 2nd and "2026-13-45" as a day in the next year. Comparing what was parsed
 * against what was asked for is what rejects the days a calendar does not have.
 *
 * @param {String} value - Date in `YYYY-MM-DD` format
 * @returns {Date|null} - The date at 00:00, or null when the string is not a real date
 */
export default function parseIsoDate(value) {
  if (!ISO_DATE_FORMAT.test(value)) return null;

  const date = stringToDate(value, 'yyyy-mm-dd');
  if (!date || isNaN(date)) return null;

  const [year, month, day] = value.split('-').map(Number);
  const isRealDate =
    date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;

  return isRealDate ? date : null;
}
